import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import { IErrorResponseSchema } from '../../repositories/dailyrent/entities/schemas/ErrorResponseSchema';

export function mapResponse400(response: IErrorResponseSchema): void {
  throw new HttpBadStatusCodeError({
    statusCode: 400,
    message: response.message || 'Error 400',
    domain: 'fetchClusters',
  });
}
